import { v1 as uuidv1 } from 'uuid'

//清除空白字段
const checkNull = (obj) => {
  if (!(typeof obj == 'object')) {
    console.warn('除去null字段的变量不是一个对象')
    return
  }

  for (let key in obj) {
    if (typeof obj[key] == 'string') {
      obj[key] = obj[key].trim()
    }
    if (
      obj.hasOwnProperty(key) &&
      (obj[key] == null || obj[key] == undefined || obj[key] == '') &&
      !(typeof obj[key] === 'number' && obj[key] == 0)
    ) {
      delete obj[key]
    }
  }
  return obj
}

//乘法
const accMul = (arg1, arg2) => {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}

//加法
const accAdd = (arg1, arg2) => {
  let r1, r2, m, c
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    let cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm
      arg2 = Number(arg2.toString().replace('.', ''))
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''))
    arg2 = Number(arg2.toString().replace('.', ''))
  }
  return (arg1 + arg2) / m
}

// 判断是否有重复值
function  isRepeat(arr) {
  let hash = {}
  for (let i in arr) {
    if (hash[arr[i]]) { return true }
    hash[arr[i]] = true
  }
  return false
}

//减法
const accSub = (arg1, arg2) => {
  let r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

//减法
const copy = (obj) => {
  return Object.assign({}, obj)
}

//判断是否为空
const checkNullObj = (obj) => {
  return Object.keys(obj).length === 0
}

const getUuid = (obj) => {
  return uuidv1().replace(/-/g, '')
}

const getIcon = (icon) => {
  if (!icon) {
    return '/icon/other.png'
  } else if (icon.indexOf('video') != -1) {
    return '/icon/video.png'
  } else if (icon.indexOf('audio') != -1) {
    return '/icon/voice.png'
  } else if (icon.indexOf('image') != -1) {
    return '/icon/image.png'
  } else if (icon.indexOf('zip') != -1) {
    return '/icon/zip.png'
  } else if (
    icon.indexOf('officedocument.spreadsheetml.sheet') != -1 ||
    icon.indexOf('excel') != -1
  ) {
    return '/icon/excel.png'
  } else if (
    icon.indexOf('officedocument.wordprocessingml.document') != -1 ||
    icon.indexOf('msword') != -1
  ) {
    return '/icon/word.png'
  } else if (
    icon.indexOf('officedocument.presentationml.presentation') != -1 ||
    icon.indexOf('powerpoint') != -1
  ) {
    return '/icon/ppt.png'
  } else if (icon.indexOf('pdf') != -1) {
    return '/icon/pdf.png'
  }
}

const getChineseNum = (num) => {
  let N = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  let str = num.toString()
  let len = num.toString().length
  let C_Num = []
  for (let i = 0; i < len; i++) {
    if (N[str.charAt(i)]) {
      C_Num.push(N[str.charAt(i)])
    } else {
      C_Num.push(i)
    }
  }
  return C_Num.join('')
}

export default {
  checkNull: checkNull,
  accMul: accMul,
  accAdd: accAdd,
  accSub: accSub,
  copy: copy,
  checkNullObj: checkNullObj,
  getUuid: getUuid,
  getIcon: getIcon,
  getChineseNum: getChineseNum,
  isRepeat
}
